"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _iconBase = _interopRequireDefault(require("../icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AdpPaginationPrevious = function AdpPaginationPrevious(props) {
  return _react.default.createElement(_iconBase.default, props, _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M0 516.416c0 281.6 230.4 512 512 512s512-230.4 512-512-230.4-512-512-512-512 230.4-512 512zm312.32 5.12c0-5.12 0-10.24 5.12-15.36l276.48-276.48c5.12-5.12 10.24-5.12 15.36-5.12h10.24l30.72 30.72c5.12 5.12 5.12 10.24 5.12 15.36s0 10.24-5.12 15.36l-225.28 235.52 230.4 230.4c5.12 5.12 5.12 10.24 5.12 15.36s0 10.24-5.12 15.36l-30.72 30.72c-5.12 5.12-10.24 5.12-15.36 5.12s-10.24 0-15.36-5.12l-276.48-276.48c-5.12-5.12-5.12-10.24-5.12-15.36z"
  })));
};

AdpPaginationPrevious.defaultProps = {
  viewBox: '0 0 1024 1043.776',
  height: '1em',
  width: '0.9811em'
};
AdpPaginationPrevious.displayName = 'AdpPaginationPrevious';
var _default = AdpPaginationPrevious;
exports.default = _default;